import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		content: {
			display: 'flex',
			alignItems: 'center',
			marginBottom: theme.spacing(2.75),
		},

		image: {
			display: 'flex',
			justifyContent: 'center',
			width: theme.spacing(6),

			'& img': {
				height: '100%',
				width: '100%',
				objectPosition: 'center bottom',
				objectFit: 'contain',
			},
		},

		text: {
			marginLeft: theme.spacing(2.75),
		},
	}),
	{ name: 'CallToAction-Cta12_13-Item' },
)

export default useStyles
